import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { StringIsNotEmptyExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringIsNotEmptyExpression";

export class StringIsNotEmptyExpressionEditor extends ExpressionRuleEditor<StringIsNotEmptyExpression> {
    render() {
        return (
            <>
                <ExpressionPiece>
                    <BracketedDiv>
                        <ExpressionValueRenderer el={this.ruleData!.value1!} />
                    </BracketedDiv>
                    <ExpressionPiece>is not empty</ExpressionPiece>
                </ExpressionPiece>
            </>
        );
    }
}
